module.exports = __webpack_public_path__ + "poppins-regular_0-webfont.e5b1f75b66ebb443987e.svg";


//////////////////
// WEBPACK FOOTER
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/assets/fonts/poppins-regular_0-webfont.svg
// module id = ../../../../../src/assets/fonts/poppins-regular_0-webfont.svg
// module chunks = 2